/* eslint-disable no-param-reassign */
import { EditorModes } from 'editor/components/EditorMode';
import MoveMarkupInteraction from 'editor/components/interactions/MoveMarkupInteraction';
import Markup from 'editor/components/Markup';
import SheetEvents from 'editor/components/SheetEvents';
import {
  MouseDownArgs,
  MouseMoveArgs,
  MouseUpArgs,
} from 'editor/systems/addSheetEvents/sheetEventHandlers';
import { getHitMarkups } from 'editor/utils/hitDetection';

const moveMarkupEvents = {
  mouseDown(args: MouseDownArgs): void {
    const { world, hit, markupKit, mode } = args;
    const { MKPoint } = markupKit;

    // Everything else in the function only has to do with non-viewonly mode.
    if (mode === EditorModes.ViewOnly) {
      return;
    }

    // TODO: You should not be able to move an RFI if you are not an admin.
    // const role = editorState.appStore.state.getCurrentUserRole();

    const point = new MKPoint(hit.x, hit.y);

    const markupEntites = getHitMarkups(world, point);

    markupEntites.forEach((entity) => {
      const markupComp = entity.get(Markup);

      world.grabAll(SheetEvents).forEach(({ component }) => {
        component.emit('move:markup:mousedown', { markupComp, hit });
      });
    });
  },

  mouseMove(args: MouseMoveArgs): void {
    const { world, hit } = args;

    world.grabAll(MoveMarkupInteraction).forEach(({ component }) => {
      component.currentX = hit.x;
      component.currentY = hit.y;
    });
  },

  mouseUp(args: MouseUpArgs): void {
    // Save moved Markup
    const { world, hit } = args;

    world.grabAll(MoveMarkupInteraction).forEach(({ entity, component }) => {
      const markupComp = entity.get(Markup);
      component.currentX = hit.x;
      component.currentY = hit.y;
      world.grabAll(SheetEvents).forEach(({ component: eventsComp }) => {
        eventsComp.emit('move:markup:mouseup', { markupComp });
      });

      entity.destroyImmediately();
    });
  },
};

export default moveMarkupEvents;
